import React, { FC } from 'react';
import { AssigneeFieldFilter } from 'components/organisms/tasks/filters/assignee';
import { MultiSelectFieldFilter } from 'components/organisms/tasks/filters/multi-select';
import { MultiUserFieldFilter } from 'components/organisms/tasks/filters/multi-user';
import { SelectFilterOperationType } from 'components/organisms/tasks/filters/select';
import { SingleSelectFieldFilter } from 'components/organisms/tasks/filters/single-select';
import { SingleUserFieldFilter } from 'components/organisms/tasks/filters/single-user';
import { SelectFiltertoHandlebarOperatorsMap } from './hb-operators-map';
import { getFieldPathForConditionalVariable } from './utils';

export const SelectFilterToText: FC<{
  filter:
    | AssigneeFieldFilter
    | SingleSelectFieldFilter
    | MultiSelectFieldFilter
    | SingleUserFieldFilter
    | MultiUserFieldFilter;
}> = ({ filter }) => {
  const { field, type } = filter;

  return (
    <>
      {`${
        SelectFiltertoHandlebarOperatorsMap[type] ?? type
      } ${getFieldPathForConditionalVariable(field)} ${
        type === SelectFilterOperationType.Is ||
        type === SelectFilterOperationType.IsOneOf ||
        type === SelectFilterOperationType.IsNoneOf ||
        type === SelectFilterOperationType.IsNot
          ? `"${filter.value}"`
          : ''
      }`.trim()}
    </>
  );
};
